export const getCacheItem = async (key: string) => {
  const item = localStorage.getItem(`cache:${key}`);
  return item ? JSON.parse(item) : null;
};

export const setCacheItem = async (key: string, value: unknown) => {
  localStorage.setItem(`cache:${key}`, JSON.stringify(value));
};

export const removeCacheItem = async (key: string) => {
  localStorage.removeItem(`cache:${key}`);
};

export const clearCache = async () => {
  const keysToRemove: string[] = [];
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key?.startsWith('cache:')) keysToRemove.push(key);
  }
  keysToRemove.forEach((key) => localStorage.removeItem(key));
};
